const STEP_GROUPS = {
  MAIN: Symbol('MAIN'),
  MY_TAXES: Symbol('MY_TAXES'),
  MY_INCOMES: Symbol('MY_INCOMES'),
  MY_INCOMES_AND_TAXDEDUCTIONS: Symbol('MY_INCOMES_AND_TAXDEDUCTIONS'),
  MY_PROPERTY: Symbol('MY_PROPERTY'),
  LAST: Symbol('LAST'),
};
export default STEP_GROUPS;
